import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { withTranslation  } from 'react-i18next';

export class Product extends Component {
  constructor(props){
    super(props);

    this.state = {
      expanded: false
    };
  }

  expandOrder = () => {
    let tempState = this.state;
    tempState.expanded = !tempState.expanded;
    this.setState(tempState);
  }

  render() {
    // eslint-disable-next-line
    let expanded = "";
    if(this.state.expanded){
      expanded = " expanded";
    }
    const { t } = this.props;
    // const statusArray = ["open", "pending", "closed"];
    // let StatusList = [];

    // for(let i = 0; i < 3; i++){
    //   StatusList.push(<Status key={i} status={i} id={this.props.id} selected={this.props.data.status}/>);
    // }

    return (
        <Card style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: this.props.login.shopify ? 'center' : '',
            flexWrap: this.props.login.shopify ? 'wrap' : ''
          }}
          className='product-card'
        >
          <CardMedia
            component="img"
            style={{
              width: 200,
              height: 200,
              padding: this.props.login.shopify ? 16 : 0
            }}
            className='product-image'
            image={this.props.data.picture_url}
            alt={this.props.data.product_name}
          />
          <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <CardContent style={{ flex: '1 0 auto' }}>
              <Typography component="div" variant="h5">
                <p>{ t('product.Name') }: <span>{this.props.data.product_name}</span></p>
              </Typography>
              <Typography variant="subtitle1" color="textSecondary" component="div">
                <p>{ t('product.SKU') }: <span> {this.props.data.product_sku}</span></p>

                {this.props.data.product_size !== "NO-SIZE" && (
                    <p>{ t('product.Size') }: <span> {this.props.data.product_size}</span></p>
                )}

                <p>{ t('product.Quantity') }: <span> {this.props.data.product_qty}</span></p>
                <p>{ t('product.Price') }: <span> {this.props.data.product_price - this.props.data.product_discount} {this.props.data.product_price_currency}</span></p>
                <p>{ t('product.WarrantyUntil') }: <span> {this.props.data.warranty_date}</span></p>
              </Typography>
            </CardContent>
          </Box>
        </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    login: state.login
  }
}

export default connect(
  mapStateToProps
)(withTranslation()(Product));



// WEBPACK FOOTER //
// ./src/js/components/Product.jsx